import { LS_KEYS } from 'CONSTANTS';

const getToken = () => {
  const item = window.localStorage.getItem(LS_KEYS.BOARD_TOKEN);
  return item ? JSON.parse(item) : '';
};

export default getToken;
